import type { IPermission } from '@mb/auth/shared';

export const CONTACTS_PERMISSION = {
  CONTACT_ADMIN: 'access.permission.contact.admin',
} as const;

export const contactsPermissionCatalog: IPermission[] = [
  {
    value: CONTACTS_PERMISSION.CONTACT_ADMIN,
    group: 'access.permission.group.contact',
    description: 'access.permission.contact.admin.description',
  },
];
